export * from './delete-ort.component';
export * from './delete-ort.component.module';